import { createMachine } from 'xstate';

import shared from 'common/bento/shared';
import { BentoModuleDoneStatus } from 'common/bento/types/BentoModule';
import { AnyMachineEvent } from 'features/Bento/types/Abstract';

import actions from './actions';
import guards, { Guard } from './guards';
import model, { Context } from './model';
import services from './services';
import { State } from './state';

const machine = createMachine<Context, AnyMachineEvent>(
  {
    context: model.initialContext,

    id: 'capitalDepositEUBankAccount',

    initial: State.FORM,

    on: {
      '*': {
        actions: shared.actions.unhandled(),
      },
    },

    states: {
      [State.FORM]: {
        entry: shared.actions.trackView(),

        on: {
          PREV: State.ABORT,
          SUBMIT: [
            {
              actions: 'assignFormData',
              cond: Guard.HasUserAnsweredNo,
              target: State.REFUSED,
            },
            {
              actions: 'assignFormData',
              target: State.DONE,
            },
          ],
        },
      },

      [State.REFUSED]: {
        entry: shared.actions.trackView(),

        on: {
          PREV: State.FORM,
        },
      },

      [State.ABORT]: {
        data: {
          status: BentoModuleDoneStatus.ABORT,
        },
        type: 'final',
      },

      [State.DONE]: {
        data: {
          status: BentoModuleDoneStatus.DONE,
        },
        type: 'final',
      },
    },
  },

  {
    actions,
    guards,
    services,
  },
);

export default machine;
